import React, { useCallback, useEffect, useState } from "react";
import { useNavigate } from "react-router-dom";
import users from "../../apiConfigs/users";
import { ReactComponent as Add } from "../../assets/add.svg";
import { ReactComponent as SearchSVG } from "../../assets/icons/search.svg";
import Pagination from "../../components/Pagination";
import Button from "../../designComponents/Button";
import Input from "../../designComponents/Input";
import Table from "../../designComponents/Table";
import {
  renderFullDetails,
  renderRole,
} from "../../designComponents/Table/renderMethods";
import { ADD_ADMIN_ROUTE } from "../../routes/routePaths";
import { humanReadableDate } from "../../utils/date";
import { debounce } from "../../utils/debounce";
import requestAPI from "../../utils/requestAPI";
import { ButtonsSection, Title, Wrapper } from "../Properties/Details/styles";
import { SearchInputWrapperStyled } from "../Users/style";

type AdminDataTypes = {
  _id: string;
  firstName: string;
  lastName: string;
  email: string;
  role: string;
  avatar: string;
  createdAt: string;
};

const Admin = () => {
  const navigate = useNavigate();
  const [paginationParams, setPaginationParams] = useState({
    page: 1,
    limit: 10,
    search: "",
    totalPages: 1,
    total: 0,
  });
  const [loading, setLoading] = useState(false);
  const [adminData, setAdminData] = useState<AdminDataTypes[]>([]);

  const getAllAdmin = async (params: any) => {
    setLoading(true);
    try {
      const query = {
        page: params.page,
        limit: params.limit,
        search: params.search,
      };
      const response = await requestAPI(users.getAdmins(query));
      setAdminData(response.data);
      setPaginationParams((prevParams) => ({
        ...prevParams,
        totalPages: response.pagination.totalPages,
        total: response.pagination.total,
      }));
      setLoading(false);
    } catch (error) {
      setLoading(false);
    }
  };

  const delayedFetch = useCallback(debounce(getAllAdmin, 300), [getAllAdmin]);

  useEffect(() => {
    delayedFetch(paginationParams);
  }, []);

  const handleInputChange = (e: React.ChangeEvent<HTMLInputElement>) => {
    const value = e.target.value;
    setPaginationParams((prevParams) => {
      const updatedParams = { ...prevParams, search: value, page: 1 };
      delayedFetch(updatedParams);
      return updatedParams;
    });
  };

  const handleCurrentPage = (page: number) => {
    delayedFetch({ ...paginationParams, page });
    setPaginationParams((prevParams) => ({ ...prevParams, page }));
  };

  const handleLimitChange = (limit: number) => {
    delayedFetch({ ...paginationParams, limit, page: 1 });
    setPaginationParams((prevParams) => ({ ...prevParams, limit, page: 1 }));
  };

  const tableData = {
    headings: [
      { key: "sn", label: "SN" },
      { key: "fullName", label: "Full Detail" },
      { key: "role", label: "Role" },
      { key: "date", label: "Date Registration" },
      // { key: "action", label: "Actions" },
    ],
    body: Array.isArray(adminData)
      ? adminData?.slice(0)?.map((user, index) => ({
          id: user?._id,
          fullName: renderFullDetails({
            avatar: user.avatar,
            firstName: user.firstName,
            lastName: user.lastName,
            email: user.lastName,
          }),
          role: renderRole(user.role),
          date: humanReadableDate(user.createdAt),
          sn: `${index + 1}.`,

          // action: renderAction({
          //   onClickDelete: () => {
          //     navigate("/");
          //   },
          //   onClickEdit: () => {
          //     navigate("/");
          //   },
          //   onClickView: () => {
          //     navigate(user._id);
          //   },
          // }),
        }))
      : [],
  };
  return (
    <Wrapper>
      <ButtonsSection>
        <Title>Admin Management</Title>
        <Button
          icon={<Add fill="#FFFFFF" height={10} width={10}></Add>}
          onClick={() => {
            navigate(ADD_ADMIN_ROUTE);
          }}
        >
          {" "}
          Add admin
        </Button>
      </ButtonsSection>
      <div
        style={{
          display: "flex",
          justifyContent: "space-between",
        }}
      >
        <div>
          <SearchInputWrapperStyled>
            <Input
              value={paginationParams.search}
              name="admin"
              onChange={handleInputChange}
              placeholder="Search admin"
              iconLeft={<SearchSVG />}
            />
          </SearchInputWrapperStyled>
        </div>
      </div>

      <Table
        rowClick={(id) => {
          navigate(id);
        }}
        tableData={tableData}
        isLoading={loading}
        noData="No data to display."
        showMenuIcon={false}
        evenRowBgColor="#fff"
      />
      <Pagination
        activePage={paginationParams.page}
        totalPages={paginationParams.totalPages}
        limit={paginationParams.limit}
        onCurrentPageChange={handleCurrentPage}
        onLimitChange={handleLimitChange}
      />
    </Wrapper>
  );
};

export default Admin;
